<ul *ngIf="newMediaMessages.length > 0">
  <li *ngFor="let mediaMessage of newMediaMessages">
    <app-media-message-item [mediaMessage]="mediaMessage"></app-media-message-item>
  </li>
  <li class="new-media-messages-separator">
    <span translate>Mobile.NewMessages</span><span>{{ since | sagaDate }}</span>
  </li>
</ul>
